import React, { Component } from 'react';
import Head from 'next/head';
import Image from 'next/image';

class AboutUs extends Component {
  render() {
    return (
      <>
        <Head>
          <meta
            name="keywords"
            content="Hidream讯梦国际公司简介，发展历程，企业资质/易赛诺公司简介，发展历程，企业资质"
          />
          <meta
            name="description"
            content="Hidream讯梦国际团队深耕海外营销10余年，自2006年成立起，始终专注于出海领域，获得海外主流平台顶级代理商资质。"
          />
        </Head>
        <div id="AboutUs" className="aboutUs">
          <div className="introduction">
            <div className="pic">
              <Image
                src={require('../public/images/电脑.png').default}
                alt="简介"
                layout="responsive"
                priority
              />
            </div>

            <div className="bottom">
              <div className="header">
                <div className="section_header_2">
                  <h3>
                    <svg className="icon" aria-hidden="true">
                      <use xlinkHref="#icon-hidream-mtitle-bg"></use>
                    </svg>
                    <span>Hidream简介</span>
                  </h3>

                  <p>Introduction to hidream</p>
                </div>
              </div>

              <div className="content">
                <p>Hidream—易赛诺（杭州）科技有限公司—专注中国品牌海外推广的跨境出海服务商。</p>
                <br />
                <p>
                  自成立以来，先后成为Google、Facebook、Bing、Instagram、YouTube、TikTok、Twitter、Yandex、Linkedln等主流海外平台顶级代理商，专注中国品牌海外推广，为中国出海企业提供免费开户、广告投放、品牌孵化等服务。
                </p>
                <br />
                <p>
                  目前成功孵化百万级DTC品牌30余个，涉及假发、家纺、服装、眼镜、家具等行业。已服务超5000余家中国品牌企业出海推广，为1000多家外贸企业培训输送2000余跨境电商人才，培训覆盖人数近15000人次。
                </p>
              </div>
            </div>
          </div>

          <div className="developmentPath">
            <div className="header">
              <div className="section_header_2">
                <h3>
                  <svg className="icon" aria-hidden="true">
                    <use xlinkHref="#icon-hidream-mtitle-bg"></use>
                  </svg>
                  <span>发展历程</span>
                </h3>
                <p>Development path</p>
              </div>
            </div>

            <div className="content">
              <div className="item">
                <div className="data">
                  <div className="year">2020年</div>
                  <div className="month">
                    <span>03</span>月
                  </div>
                </div>
                <div className="des">
                  获得 “2019年度E揽全球跨境电商’优选服务’项目”
                </div>
              </div>

              <div className="item">
                <div className="data">
                  <div className="year">2019年</div>
                  <div className="month">
                    <span>12</span>月
                  </div>
                </div>
                <div className="des">
                  举办全国首个“跨境电商出海嘉年华”杭州、厦门巡展
                </div>
              </div>

              <div className="item">
                <div className="data">
                  <div className="year">2019年</div>
                  <div className="month">
                    <span>10</span>月
                  </div>
                </div>
                <div className="des">获得 “2019年度优秀出海服务商”</div>
              </div>

              <div className="item">
                <div className="data">
                  <div className="year">2019年</div>
                  <div className="month">
                    <span>03</span>月
                  </div>
                </div>
                <div className="des">
                  获得 “2018年度E揽全球跨境电商’优选服务’项目”
                </div>
              </div>

              <div className="item">
                <div className="data">
                  <div className="year">2019年</div>
                  <div className="month">
                    <span>01</span>月
                  </div>
                </div>
                <div className="des">
                  获得 “2018数字经济优秀营销服务商”荣誉称号
                </div>
              </div>

              <div className="item">
                <div className="data">
                  <div className="year">2018年</div>
                  <div className="month">
                    <span>12</span>月
                  </div>
                </div>
                <div className="des">获得“杭州跨境电商人才社会培训基地”</div>
              </div>

              <div className="item">
                <div className="data">
                  <div className="year">2018年</div>
                  <div className="month">
                    <span>08</span>月
                  </div>
                </div>
                <div className="des">易赛诺(杭州）科技有限公司成立</div>
              </div>
            </div>
          </div>

          <div className="qualification">
            <div className="header">
              <div className="section_header_2">
                <h3>
                  <svg className="icon" aria-hidden="true">
                    <use xlinkHref="#icon-hidream-mtitle-bg"></use>
                  </svg>
                  <span>企业资质</span>
                </h3>
                <p>Qualification</p>
              </div>
            </div>

            <div className="content-wrapper">
              <div className="Google content-block">
                <Image
                  className="image"
                  src={require('../public/images/google.jpg').default}
                  alt="Google"
                />
                <div className="bottom">
                  <div className="title">Google核心合作伙伴</div>
                  <div className="content">
                    <p>2006年：获得Google核心合作伙伴资质</p>
                    <p>2012年：所服务企业入选Google中国 “十大经典案例”</p>
                    <p>2017年：实现独立站销售额从0-双百万美金</p>
                  </div>
                </div>
              </div>

              <div className="Facebook content-block">
                <Image
                  className="image"
                  src={require('../public/images/fb.jpg').default}
                  alt="Facebook"
                />
                <div className="bottom">
                  <div className="title">Facebook官方认可代理商</div>
                  <div className="content">
                    <p>
                      2018年成为Facebook官方认可的代理商，专注于中国品牌海外推广，为国内企业提供海外网络推广、广告营销课程及独立站建设的一站式海外推广解决方案。
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="content-bottom">
              <Image
                src={require('../public/images/代理.png').default}
                alt="代理logo"
              />

              <p>等主流海外平台顶级代理商</p>
            </div>
          </div>

          <div className="contantUs">
            <div className="header">
              <div className="section_header_2">
                <h3>
                  <svg className="icon" aria-hidden="true">
                    <use xlinkHref="#icon-hidream-mtitle-bg"></use>
                  </svg>
                  <span>联系我们</span>
                </h3>
                <p>Contact us</p>
              </div>
            </div>

            <div className="address">
              <Image
                src={require('../public/images/map_m.jpg').default}
                alt="Hidream地址"
              />
            </div>

            <div className="contactInformation">
              <div className="item">
                <div className="title">
                  <svg className="icon" aria-hidden="true">
                    <use xlinkHref="#icon-hidream-mjiaruwomen"></use>
                  </svg>
                  <span>加入我们</span>
                </div>
                <div className="email">E-mail：zhouyujie@Hidream.net</div>
              </div>

              {/* <div className="item">
                <div className="title">
                  <svg className="icon" aria-hidden="true">
                    <use xlinkHref="#icon-hidream-mshichanghezuo"></use>
                  </svg>
                  <span>市场合作</span>
                </div>
                <div className="email">E-mail：wangrui@Hidream.net</div>
              </div> */}

              <div className="item">
                <div className="title">
                  <svg className="icon" aria-hidden="true">
                    <use xlinkHref="#icon-hidream-mshangwuhezuo"></use>
                  </svg>
                  <span>商务合作</span>
                </div>
                <div className="email">E-mail：yeguanghui@Hidream.net</div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default AboutUs;
